import { i18n } from "..";

export enum TravelPurposeEnum {
  TURISTIC = 'turistic',
  WORK = 'work',
  SPORT = 'sport'
}


export const TravelPurposeEnumLabel = {
  [TravelPurposeEnum.TURISTIC]: i18n.t('common.constants.travelPurpose.turistic'),
  [TravelPurposeEnum.WORK]: i18n.t('common.constants.travelPurpose.work'),
  [TravelPurposeEnum.SPORT]: i18n.t('common.constants.travelPurpose.sport'),
}